import { Icon } from "./Icon";

export const SocialShare = () => {
  const shareTextFacebook = encodeURIComponent(
    "FanSided and Wingstop teamed up to match your favorite women's college basketball teams with your favorite flavors. Use our flavor finder to see how your team measures up."
  );
  const shareTextTwitter = encodeURIComponent(
    "@FanSided and @Wingstop teamed up to match your favorite women's college basketball teams with your favorite flavors. Use our flavor finder to see how your team measures up."
  );
  const shareURL = encodeURIComponent(
    "https://fansided.com/wingstop-womens-march-madness/"
  );
  return (
    <div className="socialContainer">
      <a
        href={`https://www.facebook.com/sharer.php?u=${shareURL}&t=${shareTextFacebook}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <Icon name="Facebook" social />
      </a>
      <a
        href={`https://twitter.com/intent/tweet?text=${shareTextTwitter}&url=${shareURL}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <Icon name="Twitter" social />
      </a>
    </div>
  );
};
